;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './hero-banner-resort-block.scss')]).then(() => {
    $('.widget.hero-banner-resort-block').each(function (i, el) {
      $(el).data('widget', new HeroBannerResortBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function HeroBannerResortBlock(el, Swiper, moment) {
  const self = this
  self.el = $(el)
  self.paginationContainer = self.el.find('.js-pagination-container')

  self.setVideoSource = function () {
    // Find all video elements in the widget
    const videoEls = self.el.find('video')
    if (videoEls.length === 0) return

    // Set the video source based on the screen size
    const isMobile = window.innerWidth < 640
    const isTablet = window.innerWidth >= 640 && window.innerWidth < 1024
    videoEls.each(function (i, el) {
      const videoEl = $(el)

      // Video soruces
      const mobileSrc = videoEl.attr('data-src-mobile')
      const tabletSrc = videoEl.attr('data-src-tablet')
      const desktopSrc = videoEl.attr('data-src-desktop')

      // Poster sources
      const mobilePoster = videoEl.attr('data-poster-mobile')
      const tabletPoster = videoEl.attr('data-poster-tablet')
      const desktopPoster = videoEl.attr('data-poster-desktop')

      // Set video src
      let src = desktopSrc // default
      if (isMobile && (mobileSrc || tabletSrc)) {
        src = mobileSrc || tabletSrc
      } else if (isTablet && tabletSrc) {
        src = tabletSrc
      }

      // Select poster image
      let poster = desktopPoster // default
      if (isMobile && (mobilePoster || tabletPoster)) {
        poster = mobilePoster || tabletPoster
      } else if (isTablet && tabletPoster) {
        poster = tabletPoster
      }

      if (src) {
        videoEl.attr('src', src)
        if (poster) videoEl.attr('poster', poster)
        videoEl.attr('muted', true) // NOTE: Muted is required for autoplay to work on mobile
        videoEl.attr('autoplay', true)
        videoEl.attr('playsinline', true)
        videoEl[0].load()
      }
    })
  }

  self.bindEvents = function () {
    // NOTE: Swiper can duplicate slides, so do not bind directly to the play/pause button
    self.el.on('click', '.js-video-playpause', function (e) {
      const pauseplayButton = $(this)
      const videoId = pauseplayButton.attr('aria-controls')
      // NOTE: swiper can duplicate slides, so we need to find all video elements with the same id
      const videoEl = self.el.find(`[id="${videoId}"]`)

      if (!videoEl) {
        console.warn('No video found', e)
        return
      }

      // NOTE: Swiper duplicates slides (because using 'fade' transition), because of this, if a user pauses a video in the slide,
      // the transition can have the paused video frame jump as its jumping to the duplicate slide to perform the transition between the slides.
      // There is nothing we can do about this if using 'fade' transitions.
      pauseplayButton.toggleClass('paused')
      if (pauseplayButton.hasClass('paused')) {
        videoEl.each((i, el) => el.pause())
      } else {
        videoEl.each((i, el) => el.play())
      }
    })
  }

  self.initSwiper = function () {
    // NOTE: Swiper can have nested sliders, so we need to find the first swiper instance
    const swiperEl = self.el.find('.swiper').first()
    // Find all slides in the swiper
    const slides = swiperEl.find('.swiper-slide')
    swiperEl.attr('data-slides-count', slides.length)

    // Show pagination container if there are multiple slides
    if (slides.length > 1) {
      self.paginationContainer.removeClass('!hidden')
    }

    // Get customisable configurations
    let transitionSpeed = parseInt(swiperEl.attr('data-transition-speed'))
    transitionSpeed = transitionSpeed !== NaN ? transitionSpeed : 5000

    let autoplayDelay = parseInt(swiperEl.attr('data-autoplay-delay'))
    autoplayDelay = Number.isNaN(autoplayDelay) ? undefined : autoplayDelay || 5000

    // Enable autoplay if delay is not 'disabled'
    let autoplay = false
    if (typeof autoplayDelay === 'number' && slides.length > 1) {
      autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: true,
        pauseOnMouseEnter: true, // NOTE this does not work. Maybe because old swiper version?
      }
    }

    self.swiper = new Swiper(swiperEl, {
      loop: true,
      effect: 'fade', // See: https://swiperjs.com/swiper-api#fade-effect
      crossFade: true,
      speed: transitionSpeed,
      autoplay,
      pagination: {
        el: self.el.find('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })

    // Handle autoplay start/stop
    // See: https://swiperjs.com/swiper-api#autoplay
    self.pauseplayButton = self.el.find('.js-pauseplay')
    if (typeof autoplayDelay === 'number' && self.pauseplayButton.length) {
      self.pauseplayButton.on('click', function () {
        if (self.swiper.autoplay.running) {
          self.swiper.autoplay.stop()
        } else {
          self.swiper.autoplay.start()
        }
      })

      // NOTE Using events to handle css class updates as interaction on slider also triggers autoplay stop
      self.swiper.on('autoplayStart', function () {
        self.pauseplayButton.removeClass('paused')
      })

      self.swiper.on('autoplayStop', function () {
        self.pauseplayButton.addClass('paused')
      })
    }
  }

  self.init = async function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('HeroBannerBlock init', self)
    }
    self.el.css('opacity', 1)

    self.setVideoSource()
    self.initSwiper()
    self.bindEvents()
  }
}
